/* Eupen-Anpassung 2026-10-11: Umschalter Packshot / Tragebild (Kollektion), Variante B "Am Model ansehen".
   Zustand: Klasse "eupen-worn" auf <html>, gespeichert in localStorage. Delegierter Klick-Handler,
   damit er auch nach dem AJAX-Neuladen der Filterleiste funktioniert. */
(function () {
  if (window.eupenTragebilderInit) return;
  window.eupenTragebilderInit = true;
  var KEY = 'eupenTragebilder';
  function isOn() { return document.documentElement.classList.contains('eupen-worn'); }
  function sync() {
    var on = String(isOn());
    document.querySelectorAll('[data-eupen-worn-switch]').forEach(function (el) {
      if (el.getAttribute('aria-checked') !== on) el.setAttribute('aria-checked', on);
    });
  }
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-eupen-worn-switch]');
    if (!el) return;
    event.preventDefault();
    var on = !isOn();
    document.documentElement.classList.toggle('eupen-worn', on);
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
    sync();
  });
  function init() {
    sync();
    var grid = document.querySelector('.collection-grid-section') || document.body;
    new MutationObserver(sync).observe(grid, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
